import React, { FunctionComponent, memo, useMemo, useCallback } from "react";
import { Flex, Tr, Td, Box, Text } from "@chakra-ui/react";
import { isEqual } from "lodash";


import {
  PlcMetric,
} from "../types";
import { reasonablePrecision } from "./Source";


interface IProps{
  name: string;
  unit?: string;
  value: PlcMetric | number;
  decimals?: number;
  headless?: boolean;
  secondary?: boolean;
}


const SourceMetric: FunctionComponent<IProps> = memo(function SourceMetric({
  name,
  value,
  unit,
  decimals,
  headless = false,
  secondary = false,
}) {
  const val = useMemo(() => value === null || typeof(value) === "number" ? value : value[1], [value]);
  const lineHeight = useMemo(() => secondary ? "1.5rem" : "1.2rem", [secondary]);

  const tooltip = useCallback((): string => {
    const lbl = name.replaceAll(/<[^>]+>/g, ""); // remove eventual HTML tags

    return `${lbl}: ${val} ${unit}`;
  }, [name, val, unit]);

  return <>
    <Tr verticalAlign="bottom">
      <Td p={0} pr={.5} w={"100%"} lineHeight={lineHeight}>
        <Flex justifyContent="space-between" alignItems="baseline">
          <Box mr={2} fontSize=".9rem">{!headless && name}</Box>
          <Box fontSize={lineHeight} title={tooltip()}>{reasonablePrecision(val, decimals)}</Box>
        </Flex>
      </Td>
      <Td p={0} lineHeight={lineHeight}>
        <Text fontSize={secondary ? "1.1rem" : "0.7rem"}>{unit}</Text>
      </Td>
    </Tr>
  </>
}, isEqual);

export default SourceMetric;
